import axios from "axios";

export const REQUEST_TIMEOUT_MS = 120000;
export const DASHBOARD_REQUEST_TIMEOUT_MS = 10 * 60 * 1000;

export const isLongRunningDashboardRequest = (url = "") =>
  /\/(dashboard|widgets|summary|master-data)(\/|\?|$)/i.test(url);

export const getRequestTimeout = (url) =>
  isLongRunningDashboardRequest(url)
    ? DASHBOARD_REQUEST_TIMEOUT_MS
    : REQUEST_TIMEOUT_MS;

export const masterInstacne = axios.create({ timeout: REQUEST_TIMEOUT_MS });
export const refershInstance = axios.create({ timeout: REQUEST_TIMEOUT_MS });
export const ClientInstance = axios.create({ timeout: REQUEST_TIMEOUT_MS });
